import { render, staticRenderFns } from "./Margin.vue?vue&type=template&id=5cab1bb8&scoped=true&"
import script from "./Margin.js?vue&type=script&lang=js&"
export * from "./Margin.js?vue&type=script&lang=js&"
import style0 from "./Margin.vue?vue&type=style&index=0&id=5cab1bb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab1bb8",
  null
  
)

export default component.exports